import * as tslib_1 from "tslib";
import getChoiceGroupSelection from '../utils/getChoiceGroupSelection';
import getForwardingEmailAddress from '../utils/getForwardingEmailAddress';
import getKeepCopy from '../utils/getKeepCopy';
import { saveMailboxForwardingConfiguration } from 'owa-forwarding-configuration';
import { action } from 'satcheljs/lib/legacy';
export default action('saveForwardingOption')(function saveForwardingOption() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var isForwardingEnabled, forwardingEmailAddress, keepCopy, mailboxOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isForwardingEnabled = getChoiceGroupSelection() === 'start';
                    forwardingEmailAddress = isForwardingEnabled ? getForwardingEmailAddress() : null;
                    keepCopy = getKeepCopy();
                    mailboxOptions = {
                        AddressString: forwardingEmailAddress,
                        DeliverToMailboxAndForward: keepCopy,
                    };
                    return [4 /*yield*/, saveMailboxForwardingConfiguration(mailboxOptions)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=saveForwardingOption.js.map